var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55822 5.52699C1 6.87464 1 8.5831 1 12C1 15.4169 1 17.1254 1.55822 18.473C2.30251 20.2699 3.73012 21.6975 5.52699 22.4418C6.87464 23 8.5831 23 12 23C15.4169 23 17.1254 23 18.473 22.4418C20.2699 21.6975 21.6975 20.2699 22.4418 18.473C23 17.1254 23 15.4169 23 12C23 8.5831 23 6.87464 22.4418 5.52699C21.6975 3.73012 20.2699 2.30251 18.473 1.55822C17.1254 1 15.4169 1 12 1C8.5831 1 6.87464 1 5.52699 1.55822C3.73012 2.30251 2.30251 3.73012 1.55822 5.52699Z",
    fill: "#F9C825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6.27081C12.5063 6.27081 12.9167 6.68122 12.9167 7.18748V16.8125C12.9167 17.3187 12.5063 17.7291 12.0001 17.7291C11.4938 17.7291 11.0834 17.3187 11.0834 16.8125V7.18748C11.0834 6.68122 11.4938 6.27081 12.0001 6.27081Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27092 12C6.27092 11.4937 6.68132 11.0833 7.18758 11.0833H16.8126C17.3188 11.0833 17.7292 11.4937 17.7292 12C17.7292 12.5062 17.3188 12.9166 16.8126 12.9166H7.18758C6.68132 12.9166 6.27092 12.5062 6.27092 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPlus);
export default __webpack_public_path__ + "static/media/selected_plus.7d307328.svg";
export { ForwardRef as ReactComponent };